// Which faction each camp flies (§31 G3): factions in random order.
//
// **A run's order is one shuffle off its seed**, so a log carries no list: the
// stage indexes the order, cycling past its end. Only the factory army ships
// (§31 R2), so today every stage answers `KING_FACTORY` — the order is the
// hook X1's Dragon Dens hang on, and `next-stage.kings` is the door it lands
// through.

import { FACTIONS } from "../position";
import { streamFor } from "../random";

/** After the generator's 139–143. */
export const FACTION_ORDER_STREAM = 144;

/** The run's faction order: a Fisher–Yates shuffle of `factions` off the seed. */
export function factionOrder(seed: number, factions: readonly number[] = FACTIONS): number[] {
  const order = [...factions];
  const roll = streamFor(seed, 0, FACTION_ORDER_STREAM);
  for (let i = order.length - 1; i > 0; i--) {
    const j = Math.floor(roll() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }
  return order;
}

/** The faction stage `stage` (from one) arrives as. */
export function factionForStage(
  seed: number,
  stage: number,
  factions: readonly number[] = FACTIONS
): number {
  const order = factionOrder(seed, factions);
  return order[(((stage - 1) % order.length) + order.length) % order.length];
}
